/**
 * @requires basiclightbox
 */

import * as basicLightbox from 'basiclightbox';

document.addEventListener( 'alpine:init', () => {

	Alpine.data( 'renderingLightbox', ( config = {}) => ({

		url      : config.url || '',
		lightbox : null,
		onKeyDown: null,

		/**
		 * The share URL with Autodesk's own "continue in the browser" flag set.
		 *
		 * On mobile, Autodesk's viewer navigates the frame to its app-install
		 * interstitial ( /m/index.jsp ), which is served with
		 * X-Frame-Options: SAMEORIGIN and so cannot render inside our iframe —
		 * the lightbox comes up blank. That interstitial's own markup builds a
		 * "continue to web" link as targetUrl + "?webOnly=true", so we ask for
		 * that up front. Cross-origin framing rules mean we can never detect
		 * whether it worked, hence the always-present escape hatch below.
		 */
		embedUrl() {
			if ( ! this.url ) {
				return '';
			}

			try {

				// Deliberately parsed with no base: a base would resolve a
				// malformed or relative value against our own origin instead of
				// throwing, pointing the frame at this site.
				const parsed = new URL( this.url );

				parsed.searchParams.set( 'webOnly', 'true' );

				return parsed.toString();
			} catch {

				// Not an absolute URL: use it exactly as authored.
				return this.url;
			}
		},

		markup() {
			return `<div class="rendering-lightbox__inner">
				<button class="rendering-lightbox__close" aria-label="Close">&#x2715;</button>
				<div class="rendering-lightbox__frame">
					<iframe src="${ this.embedUrl() }" title="3D rendering" frameborder="0" allowfullscreen></iframe>
				</div>
				<p class="rendering-lightbox__fallback">
					<a href="${ this.url }" target="_blank" rel="noopener noreferrer">Rendering not loading? Open it in a new tab</a>
				</p>
			</div>`;
		},

		open() {
			this.lightbox = basicLightbox.create(
				this.markup(),
				{
					onClose: ( instance ) => {
						const iframe = instance.element().querySelector( 'iframe' );
						if ( iframe ) iframe.src = '';

						document.removeEventListener( 'keydown', this.onKeyDown );
					},
				}
			);

			this.onKeyDown = ( event ) => {
				if ( 'Escape' === event.key ) this.close();
			};

			document.addEventListener( 'keydown', this.onKeyDown );

			this.lightbox.show();

			this.lightbox.element().querySelector( '.rendering-lightbox__close' ).addEventListener( 'click', () => this.close() );
		},

		close() {
			if ( this.lightbox ) this.lightbox.close();
		},

	}) );
});
